import { observer } from 'mobx-react-lite'
import React, { Fragment, useContext } from 'react'
import { SearchContext } from '../../../../contexts/SearchContext'
import ReactMultiSelect from '../../../FormComponents/ReactMultiSelect'

export default observer(function ExtraFiltersSelector() {
  const { search } = useContext(SearchContext)

  const filterOptions = [
    { label: 'Reach', value: 'reach' },
    { label: 'Country', value: 'country' },
    { label: 'Engagement Rate', value: 'engagement_rate' },
    { label: 'City', value: 'city' },
    { label: 'Gender', value: 'gender' },
    { label: 'Age Group', value: 'age_group' },
    { label: 'Audience Gender', value: 'audience_gender' },
    { label: 'Audience Age Groups', value: 'audience_age_groups' },
    { label: 'Audience Cities', value: 'audience_cities' },
    { label: 'Audience Countries', value: 'audience_countries' },
  ]

  const onChange = filters => search.selectedFilters = filters

  return (
    <Fragment>
      <div className="w-80">
        <ReactMultiSelect
          placeholder="Select Filters"
          name="filter"
          onChange={onChange}
          options={filterOptions}
          value={search.selectedFilters}
          disableSearch
          hasSelectAll={false}
        />
      </div>
    </Fragment>
  )
})